import type { ReactNode } from "react"

import {
  cn,
  DialogContent,
  dialogContentVariants,
  DialogOverlay,
} from "@coval/ui"
import { Content } from "@radix-ui/react-dialog"

interface PickerCatalogContentProps {
  className?: string
  children: ReactNode
  presentation: "dialog" | "picker-panel"
}

export function PickerCatalogContent({
  presentation,
  className,
  children,
}: PickerCatalogContentProps) {
  if (presentation === "dialog") {
    return <DialogContent className={className}>{children}</DialogContent>
  }

  // Keep the nested dialog in the picker DOM so its panel and focus boundary belong to that modal.
  return (
    <>
      <DialogOverlay className="absolute inset-0 rounded-lg bg-transparent" />
      <Content
        className={cn(
          dialogContentVariants(),
          "absolute inset-x-3 top-auto bottom-3 h-[72%] w-auto max-w-none translate-x-0 translate-y-0 rounded-lg data-[state=open]:slide-in-from-bottom-4 data-[state=open]:zoom-in-100 data-[state=closed]:slide-out-to-bottom-4 data-[state=closed]:zoom-out-100",
        )}
      >
        {children}
      </Content>
    </>
  )
}
